module.exports = __webpack_public_path__ + "static/SavorlyLogoNav-2ef8e390c54a5606a9cd012341f38541.png";